/* eslint-disable */
async function download(file) {
  if (!file) {
    return;
  }
}

export default download;
